import styled from "styled-components";

//Divs principais

//Navegacao

export const PerfilNavMobile = styled.div`
    display: none;

    @media (max-width: 425px) {
    max-height: ${props => (props.visivel ? '150%' : '0')};
    width: 80%;
    background-color: #FFF;
    position: absolute;
    display: flex;
    overflow: hidden;
    box-shadow: 0px 13px 19px 0px rgba(0, 0, 0, 0.07);
    transition: max-height 0.6s ease;
    left: 10;
    // top: 602px;
    z-index:1;
    border-radius: 0px 0px 10px 10px;
    }
`;

export const ContainerPerfil = styled.div`
    display:flex;
    flex-direction:column;
    // height:130vh;
    position: relative;

    @media (max-width: 425px) {
     height:180vh;
    }

`

export const ContainerButtomMobile = styled.div`
    width: 30%;

    @media (max-width: 425px) {
    width: 50%;
    }

    @media (max-width: 375px) {
    width: 60%;
    }

`

export const BoxConta = styled.div`
    display:flex;
    flex-direction:column;
    // height:130vh;
    margin:0px 74px 0px 74px;

    @media (max-width: 425px) {
    margin:0px 15px 0px 15px;
    height:180vh;
    }

    @media (min-width: 768px) and (max-width: 1024px)   {
    margin:0px 35px 0px 35px;
    }
`

export const BannerPerfil = styled.div`
    display: flex;
    width: 100%;
    height: 250px;
    justify-content: flex-end;
    align-items: flex-end;
    flex-shrink: 0;
    border-radius: 20px;
    background: #F5F5F5;
    // position: relative; /* Permite posicionamento absoluto de filhos */
    overflow: hidden;

    @media (max-width: 425px) {
    align-items: flex-start;
    }
`

export const BoxAddFoto = styled.div`
    padding-right:74.563px;
    padding-bottom:24px;

    @media (max-width: 425px) {
    padding:15px;
    }

    @media (min-width: 768px) and (max-width: 1024px)  {
    padding-right:30px;
    }
`

export const ButtonAddFoto = styled.div`
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.70);
    cursor:pointer;
`

export const ContainerFotosUsuario = styled.div`
    padding-bottom:69px;
`

export const ContainerInfoUsuario = styled.div`
    display:inline-flex;
    gap:30px;
    position: absolute; /* Posiciona absolutamente dentro de BannerPerfil */
    top: 190px;
    padding-left:74.563px;
    z-index:0;

    @media (max-width: 425px) {
    padding-left:20px;
    // top: 410px;
    top: 200px;
    gap:20px;perfil
    }

    @media (max-width: 320px) {
    padding-left:10px;
    gap:15px;
    }

    @media (min-width: 768px) and (max-width: 1024px)  {
    padding-left:30px;
    }
`

export const FotoUsuario = styled.div`
    width: 130px;
    height: 130px;
    flex-shrink: 0;
    border-radius: 20px;
    background: #848484;
    display:flex;
    justify-content: flex-end;
    align-items: flex-end;
    overflow: hidden;

    @media (max-width: 425px) {
    width: 110px;
    height: 110px;
    }

     @media (max-width: 375px) {
    width: 100px;
    height: 100px;
    }
`

export const InfoUsuario = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: flex-end;
    align-items: flex-start;

     
`

export const InfoUsuarioMargin = styled.div`
    margin-bottom: 8px;

`

//Fonts

export const P1 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P2 = styled.p`
    color: #000;
    // text-align: center;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;

    @media (max-width: 425px) {
    font-size: 12px;
    white-space: nowrap;
    margin-top:10px;
    }

    @media (max-width: 360px) {
    font-size: 10px;
    white-space: nowrap; 
    }
`

export const P3 = styled.p`
    color: var(--Cinza-2, #848484);
    // text-align: center;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;

    @media (max-width: 425px) {
    font-size: 10px;
    white-space: nowrap; 
    }

    @media (max-width: 360px) {
    font-size: 8px;
    white-space: nowrap; 
    }
`

export const P4 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
    white-space: nowrap;
`

export const P5 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;
`

export const P6 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
    margin-bottom:3px;
`

export const P7 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P8 = styled.p`
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P9 = styled.p`
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`

export const P10 = styled.p`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`

export const P11 = styled.p`
    color: var(--Cinza-2, #848484);
    text-align: center;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`

//Minha conta

export const ContainerNavPerfil = styled.div`
    border-top: solid 1px #D2D2D2;
    margin:25px 80px 10px 80px;

    @media (max-width: 425px) {
    margin:25px 25px 10px 25px;
    border-top: none;
    }

    @media (max-width: 320px) {
    margin:25px 15px 10px 15px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
    margin:25px 30px 10px 30px;
    }
`

export const BoxNavPerfil = styled.div`
    display: flex;
    // width: 110px;
    height: 35px;
    padding: 10px 10px 10px 0px;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    @media (max-width: 425px) {
    display:none;
    }
`

export const BoxNavPerfilMobile = styled.div`
    display: none;

    @media (max-width: 425px) {
        display: block;
    }
`

export const InputBoxNavMobile = styled.div`
    @media (max-width: 425px) {
        display: inline-flex;
        padding: 8px 0px 7.14px 13px;
        justify-content: space-between;
        align-items: center;
        // gap: 239px;
        width:95%;

        border-radius: 10px;
        border: 1px solid var(--cinzaClaro, #D2D2D2);
    }
`

export const DivBoxnav = styled.div`
    @media (max-width: 425px) {
    }
`

export const BoxnavSeta = styled.div`
    @media (max-width: 425px) {
       border-left: 1px solid rgba(179, 179, 179, 0.50);

       display: flex;
        // width: 31px;
        // height: 19.86px;
        padding: 4.92px 12px 4.94px 9px;
        justify-content: center;
        align-items: center;
    }
`

export const SetaBaixoNav = styled.div`
    @media (max-width: 425px) {
        transition: transform 0.3s ease; /* Adiciona uma transição suave para a rotação */
        transform: ${props => (props.visivel ? 'rotate(-180deg)' : 'rotate(0deg)')}; /* Rotaciona a seta */
    }
`

export const DivNavPerfil = styled.div`
    display: flex;
    height: 20px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-bottom: ${(props) => (props.isActive ? '1px solid #000' : '')};
    cursor: pointer;

    &:hover {
        border-radius: 5px;
        background: #F4F4F4;
    }
`;

export const DivNavPerfilMobile = styled.div`
    display: flex;
    height: 20px;
    padding: 10px;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-bottom: ${(props) => (props.isActive ? '1px solid #000' : '')};
    cursor: pointer;
`;

export const NavMobile = styled.div`
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    width:100%;
`;

// export const DivNavPerfilPrincip = styled.div`
//     display: flex;
//     height: 20px;
//     padding: 10px;
//     justify-content: center;
//     align-items: center;
//     gap: 10px;
//     flex-shrink: 0;
//     border-bottom: 1px solid #000;
//     cursor: pointer;
// `;

export const BoxMinhaConta = styled.div`
    display:flex;
    flex-direction:column;
    gap:25px;
    // margin-top:45px;
    margin: 45px 80px 10px 80px;

    @media (max-width: 425px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 320px) {
    margin: 45px 20px 10px 20px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
    margin: 45px 30px 10px 30px;
    }
`

export const BoxInfoMinhaContaMobile = styled.div`
    display:flex;
    flex-direction:column;
    gap:25px;

    @media (max-width: 425px) {
    margin-top:40px;
    }
`

export const InfoMinhaConta = styled.div`
    display:flex;
    justify-content: space-between;
    gap:20px;
    // width:90%;

    @media (max-width: 425px) {
    flex-direction:column;
    }
`

export const BoxInfoMinhaConta = styled.div`
    display:flex;
    flex-direction:column;
    // width:100%;
    gap:15px;
`

export const BoxInformacoes = styled.div`
`

export const ContainerFlex = styled.div`
    display:flex;
    gap:20px;

    @media (max-width: 425px) {
    gap:8px;
    }

    @media (max-width: 375px) {
    flex-direction:column;
    gap:8px;
    }

    @media (min-width: 768px) and (max-width: 1020px) {
    flex-direction:column;
    gap:8px;
    }
`


export const BoxCheckbox = styled.div`
    display:flex;
    gap:5px;
    align-items: center;
`

export const BoxAdd = styled.div`
    cursor:pointer;
`

// Minha Carteira

export const BoxMinhaCarteira = styled.div`
    display:flex;
    flex-direction:column;
    gap:25px;
    // margin-top:45px;
    margin: 45px 80px 10px 80px;

    @media (max-width: 425px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 320px) {
    margin: 45px 20px 10px 20px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
    margin: 45px 30px 10px 30px;
    }
`

export const InfoMinhaCarteira = styled.div`
    display:flex;
    flex-direction:column;
    gap:25px;
`

export const BoxInfoMinhaCarteira = styled.div`
    display:flex;
    flex-direction:column;
`

export const BoxInfoMinhaCarteiraFlex = styled.div`
    display:flex;
    gap:20px;
    overflow-x:auto;

     /* Torne a barra de rolagem invisível no Webkit */
    &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    /* Outros estilos para Firefox */
    scrollbar-width: none; /* Firefox */

    & {
        -ms-overflow-style: none;  /* IE and Edge */
    }

    // @media (max-width: 425px) {
    // overflow-x:auto;
    // }
    
`

export const CardCartao = styled.div`
    width: 245px;
    height: 154px;
    flex-shrink: 0;
    border-radius: 20px;
    border: 1px solid var(--cinzaClaro, #D2D2D2);

    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
`


export const BoxInfoCartao = styled.div`
    text-align:center;
`
export const BoxInfoCartaoAtivo = styled.div`
    width:100%;
    margin:28px 28px 28px 28px;
`

export const CardBandeira = styled.div`
    width: 35px;
    height: 20px;
    flex-shrink: 0;
    border-radius: 3px;
    background: #051F51;
    display:flex;
    justify-content:center;
    align-items:center;
`


export const P14 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;
    margin-bottom:5px;
    margin-top:15px;
`


export const P15 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;
    margin-bottom:15px;
`


export const P16 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`


//Meus enderecos

export const BoxMeusEnderecos = styled.div`
    margin: 45px 80px 10px 80px;

    @media (min-width: 768px) and (max-width: 1024px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 425px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 320px) {
    margin: 45px 20px 10px 20px;
    }
`

export const InfoMeusEnderecos = styled.div`
    // margin-top:45px;
    display:flex;
    flex-direction:column;
    gap:20px;
`

export const BoxInfoMeusEnderecos = styled.div`
    display:flex;
    flex-direction:column;
`

export const BoxInfoMeusEnderecosFlex = styled.div`
    display:flex;
    gap:20px;
    overflow-x:auto;
    width: 100%;

     /* Torne a barra de rolagem invisível no Webkit */
    &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    /* Outros estilos para Firefox */
    scrollbar-width: none; /* Firefox */

    & {
        -ms-overflow-style: none;  /* IE and Edge */
    }

    // @media (max-width: 425px) {
    // overflow-x:auto;
    // width: 100%;
    // }
    
`

export const CardEndereco = styled.div`
    width: 551px;
    height: 240px;
    flex-shrink: 0;
    border-radius: 20px;
    border: 1px solid var(--cinzaClaro, #D2D2D2);

    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
    
`

export const BoxInfoEndereco = styled.div`
    text-align:center;
`

export const BoxInfoEnderecoAtivo = styled.div`
`

export const BoxEnderecoAtivoFlex = styled.div`
    display:flex;
    justify-content:space-between;
    // align-items:flex-end;
    gap:175px;
    margin-bottom:25px;

`

export const BoxEnderecoAtivoFlex2 = styled.div`
    display:flex;
    flex-direction:column;
    gap:8px;
    width: 75%;

`

export const EnderecoAtivoFlex = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:5px;
`

export const BoxFlexInfoAtivo = styled.div`
    width:100%
`

export const BoxEnderecoEditar = styled.div`
    display: inline-flex;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: rgba(210, 210, 210, 0.50);
`

export const BoxEnderecoExcluir = styled.div`
    display: inline-flex;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid rgba(210, 210, 210, 0.50);
`

export const P17 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P18 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P19 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`

export const P20 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
    white-space: nowrap;
`


//Meus Pedidos

export const BoxMeusPedidos = styled.div`
    margin: 45px 80px 10px 80px;

    @media (min-width: 768px) and (max-width: 1024px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 425px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 320px) {
    margin: 45px 20px 10px 20px;
    }
`

export const InfoMeusPedidos = styled.div`
    // margin-top:45px;
    display:flex;
    flex-direction:column;
    gap:20px;
    // width: 813px;

    @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    }

    @media (max-width: 425px) {
    width: 100%;
    }
`

export const BoxInfoMeusPedidos = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:flex-end;
`

export const BoxInfoMeusPedidosFlex = styled.div`
    display:flex;
    flex-direction:column;
    height: 20%;
    overflow: auto;
`

export const DivPesquisa = styled.div`
    display: inline-flex;
    padding: 6px 18px;
    align-items: flex-start;
    gap: 10px;
    border-radius: 15px;
    background: #F5F5F5;

    @media (max-width: 425px) {
    display:none;
    }
`

export const InputPesquisa = styled.input`
    outline:none;
    border:none;
    background:none;
`

export const BoxInfoPedidos = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;

    border-bottom: solid 1px #000;

    @media (max-width: 425px) {
    border:none;
    }
`

export const NavInfoPedidos = styled.div`
    display:flex;
    width:80%;
    @media (max-width: 425px) {
    display:none;
    }
`

export const P24 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

`

export const CardPedidos = styled.div`
    height:40vh;
    display:flex;
    justify-content:center;
    align-items:center;
`

export const CardPedidosAtivo = styled.div`
`

export const CardNavPedidos = styled.div`
    display:flex;
    border-bottom:solid 1px #D2D2D2;
    padding: 24px 0px 24px 0px;

    @media (max-width: 425px) {
    flex-direction:column;
    gap:10px;
    }
`

export const BoxInfoNavPedidos = styled.div`
    display:inline-flex;
    flex-direction:column;
    align-items: flex-start;
    width:100%;
`

export const BoxInfoPedidos2 = styled.div`
    text-align:center;
`

export const BoxFlexPedido = styled.div`
    display:flex;
    gap:20px;
    // width:100%;
`

export const P21 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P22 = styled.p`
    color: #1FA10A;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P23 = styled.p`
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`

export const P25 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

export const P26 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
    
`
export const P27 = styled.p`
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin:0;
`

export const BoxPedidoItem = styled.div`
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:center;
    gap:10px;
`

//Minha lista de desejos

export const BoxMinhaListaDesejos = styled.div`
    display:flex;
    flex-direction:column;
    gap:25px;
    // margin-top:45px;
    margin: 45px 80px 10px 80px;
    height:60vh;

    @media (min-width: 768px) and (max-width: 1024px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 425px) {
    margin: 45px 30px 10px 30px;
    }

    @media (max-width: 320px) {
    margin: 45px 20px 10px 20px;
    }
`

export const InfoMeusDesejos = styled.div`
`
export const InfoMeusDesejosFlex = styled.div`
`
export const CardListDesejos = styled.div`
    // height:70vh;
    display:flex;
    align-items:flex-start;
    gap:25px;
    overflow-x:auto;
    margin-bottom:50px;

    @media (max-width: 425px) {
    // flex-direction:column;
    // justify-content:center;
    align-items:center;
    }

`

export const AddItemLista = styled.div`
    margin-top: 50px;

    @media (max-width: 425px) {
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin-top: 50px;
    width: 100%;
    }

`

export const CardAddDesejos = styled.div`
    display:inline-flex;
    text-align:center;
    gap:20px;

    @media (max-width: 425px) {
    flex-direction:column;
    justify-content:center;
    align-items:center;
    }
`

export const BoxAddDesejo = styled.div`
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:center;

    @media (max-width: 425px) {
    flex-direction:column;
    justify-content:center;
    align-items:center;
    }
`

export const P12 = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    margin:0;
    margin-bottom:3px;
`

export const P13 = styled.p`
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:0;
`

//Modal Cartao

export const ContainerModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Fundo com opacidade */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ContainerInfoScrooll = styled.div`

    @media (max-width: 425px) {
    height: 570px;
    overflow-y:auto;
    overflow-x: hidden;
    }
`;

export const BoxModalCartao = styled.div`
    display:flex;
    flex-direction:column;

`;

export const InfoModalCartao = styled.div`
    // background: #fff;
    // padding: 20px;
    // border-radius: 8px;
    // /* Adicione mais estilos conforme necessário */
    display: inline-flex;
    width: 656px;
    height: 100%;
    padding: 36px 63px 35.95px 63px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;
    flex-shrink: 0;
    border-radius: 40px;
    background: #FFF;

    @media (max-width: 425px) {
    width: 80%;
    height: 140%;
    padding: 10px 20px 15px 20px;
    margin: 5px 20px 20px 20px;
    }

`;


export const BoxFlexmodal = styled.div`
    display: flex;
    align-items: center;
    gap:300px;
    justify-content: space-around;
    padding-bottom:24px;

    @media (max-width: 425px) {
    gap:10px;
    padding-bottom:4px;
    padding-top:20px;
    }
`;

export const P1Modal = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin:0;

    @media (max-width: 425px) {
    font-size: 20px;
    }
`;

//Produto desejo

export const BoxProduto = styled.div`
    display:flex;
    gap:15px;
    flex-direction:column;
`;

export const InfoProduto = styled.div`
    gap:15px;
    display:flex;
    flex-direction:column;
`;